import { all, call, cancelled, put, takeLatest } from "redux-saga/effects";
import LearningPathwayService from "../../services/LearningPathwayService";

import {
  listSuccess,
  listFail,
  createSuccess,
  createFail,
  detailsSuccess,
  detailsFail,
  updateDetailSuccess,
  updateDetailFail,
  assignmentsSuccess,
  assignmentsFail,
  addAssignmentSuccess,
  addAssignmentFail,
  deleteAssignmentSuccess,
  deleteAssignmentFail,
} from "../slices/learningPathwaySlice";

import {
  learningProgramSuccess,
  learningProgramFail,
} from "../slices/metaSlice";

function* dropwdown(data) {
  try {
    const ajax = yield call(LearningPathwayService.dropDown, data.payload);
    if (ajax.status === 200) {
      yield put(learningProgramSuccess(ajax.data));
    } else {
      yield put(
        learningProgramFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      learningProgramFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* list(data) {
  try {
    const ajax = yield call(LearningPathwayService.list, data.payload);
    if (ajax.status === 200) {
      yield put(listSuccess(ajax.data));
    } else {
      yield put(
        listFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      listFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* create(data) {
  try {
    const ajax = yield call(LearningPathwayService.create, data.payload);
    if (ajax.status === 200) {
      yield put(createSuccess(ajax.data));
    } else {
      yield put(
        createFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      createFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* details(data) {
  try {
    const ajax = yield call(LearningPathwayService.details, data.payload);
    if (ajax.status === 200) {
      yield put(detailsSuccess(ajax.data));
    } else {
      yield put(
        detailsFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      detailsFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* update(data) {
  try {
    const ajax = yield call(LearningPathwayService.update, data.payload);
    if (ajax.status === 200) {
      yield put(updateDetailSuccess(ajax.data));
    } else {
      yield put(
        updateDetailFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      updateDetailFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* assignments(data) {
  try {
    const ajax = yield call(LearningPathwayService.assignments, data.payload);
    if (ajax.status === 200) {
      yield put(assignmentsSuccess(ajax.data));
    } else {
      yield put(
        assignmentsFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      assignmentsFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* addAssignment(data) {
  try {
    const ajax = yield call(
      LearningPathwayService.createAssignment,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(addAssignmentSuccess(ajax.data));
    } else {
      yield put(
        addAssignmentFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      addAssignmentFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* deleteAssignment(data) {
  try {
    const ajax = yield call(
      LearningPathwayService.deleteAssignment,
      data.payload
    );
    if (ajax.status === 200) {
      yield put(deleteAssignmentSuccess(ajax.data));
    } else {
      yield put(
        deleteAssignmentFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      deleteAssignmentFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

export default function* learningPathwaySaga() {
  yield all([
    takeLatest("learningPathways/listRequest", list),
    takeLatest("learningPathways/createRequest", create),
    takeLatest("learningPathways/detailsRequest", details),
    takeLatest("learningPathways/updateDetailRequest", update),
    takeLatest("learningPathways/assignmentsRequest", assignments),
    takeLatest("learningPathways/addAssignmentRequest", addAssignment),
    takeLatest("learningPathways/deleteAssignmentRequest", deleteAssignment),
    takeLatest("meta/learningProgramRequest", dropwdown),
  ]);
}
